module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Da-Ge-Ha-Ia-inside.d054c1f5.png";